import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import styled from "styled-components";
import { FormControl, InputLabel, Grid, Input } from "@material-ui/core";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import PrimaryButton from "components/Global/Buttons/PrimaryButton";
import PageWrapper from "components/Global/PageOrganization/PageWrapper";

import { yieldCurves } from "../../Constants/DropDownLists";
import {
  StyledGrid,
  YieldResults
} from "../../Constants/StyledComponents";
import DropDownFormControl from "../Components/DropDownFormControl";

const ButtonBar = styled(Grid)`
  display: flex;
  align-items: flex-end;
  justify-content: flex-start;
`;
class YieldTestHarnessSearch extends Component {
  render() {
    const {
      testHarness: { testData },
      classes
    } = this.props;

    return (
      <PageWrapper>
        <Grid container direction="row">
          <StyledGrid item xs={2}>
            <DropDownFormControl
              htmlFor="yieldCurve"
              labelName="Yield Curve"
              value={this.props.state ? this.props.state.curve.toString() : ""}
              onChange={this.props.handleChange}
              inputProps={{ name: "curve" }}
              menuItemList={yieldCurves}
            />
          </StyledGrid>
          <StyledGrid item xs={2}>
            <FormControl className="selectMenu">
              <InputLabel htmlFor="tenorValue">Tenor Value</InputLabel>
              <Input
                type="text"
                name="tenorValue"
                value={this.props.state.tenorValue.toString()}
                onChange={this.props.handleChange}
              />
            </FormControl>
          </StyledGrid>
          <ButtonBar item xs={1}>
            <PrimaryButton
              onClick={this.props.submit}
            >
              Submit
            </PrimaryButton>
          </ButtonBar>
        </Grid>
        <Grid container alignItems="flex-start" direction="row">
          <StyledGrid item xs={5}>
            {testData && testData.yieldCurveResult ? (
              <div>
                <YieldResults elevation15>
                  <Typography variant="h5" component="h3">
                    Yield for a Tenor of
                    {" "}
                    {this.props.state.tenorValue}
                    {" "}
                    year(s)
                    is
                  </Typography>
                  <Typography component="p">
                    {testData.yieldCurveResult.toFixed(5)}
                    %
                  </Typography>
                </YieldResults>
              </div>
            ) : null}
          </StyledGrid>
        </Grid>
      </PageWrapper>
    );
  }
}

const mapStateToProps = ({ testHarness }) => ({
  testHarness
});

export default compose(connect(mapStateToProps))(YieldTestHarnessSearch);
